import axios from 'axios'

axios.defaults.baseURL = 'http://api.bergregions.pl'

export default {
  checkIdentity: (mac, serial)  => axios.get(`/api/v2/cms/init/identity/${mac}?serial=${serial}`),
  getDevice: (mac, serial) => axios.get(`/api/v1/device/${mac}?serial=${serial}`),
  getApp: mac => axios.get(`/api/v1/tv-app/device/${mac}`),
  getAppById: appId => axios.get(`/api/v1/tv-app/preview/${appId}`),
  setIdentity: data => axios.post('/api/v2/cms/init', data),
  setInitData: (mac, fw, appVersion, ip, model) => axios.patch(`api/v1/bhs/cms/init/signage/${mac}?frontendAppVersion=${appVersion}&lgFirmwareVersion=${fw}&ip=${ip}&tvModel=${model}`)
}
